import React, { useState, useEffect } from "react";
import {
  getPrearrivalsRecord,
  sendPreArrivalNotificationEmail,
} from "services/prearrivals"
import { Icon, Popup } from "semantic-ui-react"
import Loader from "components/Loader";
// import { preArrivalsDummy } from "utils/dummyData";
import ListTable from "components/PreArrival/ListTable";
import FilterPopup from "components/PreArrival/FilterPopup";
import BookingResultsPopup from "components/PreArrival/BookingResultsPopup";
import FilterBar from "components/PreArrival/FilterBar";
import EditPopup from "components/PreArrival/EditPopup";
import DeletePopup from "components/PreArrival/DeletePopup";
import MessagePopup from "components/MessagePopup";
import dayjs from "dayjs";
import Statistic from "components/PreArrival/Statistic";


export default function PreArrival(props: any) {
  // const [initialFetch, setInitialFetch] = useState<boolean>(true)
  const { hotel } = props
  const isDmel = hotel?.id === "6449e7e5abd582feb900edbd"
  const [loading, setLoading] = useState(false)
  const [fetchCount, setFetchCount] = useState(0)
  const [filter, setFilter] = useState({ notSend: false, filtering: false })
  const [pagination, setPagination] = useState<any>({
    total: null,
    page: 1,
    itemsPerPage: 25,
    totalPages: 1,
    sortBy: "checkInDate.desc",
  })
  const [bookingFilter, setBookingFilter] = useState<any>({
    bookingNumber: null,
    email: null,
    fullName: null,
    firstName: null,
    lastName: null,
  })
  const [preArrivals, setPreArrivals] = useState<any>(null)
  const [bookings, setBookings] = useState<any>(null)
  const [popup, setPopup] = useState<any>({
    searchBooking: false,
    bookings: false,
    edit: false,
    delete: false,
  })
  const [editRecord, setEditRecord] = useState<object | null>(null)

  /* use for editPopup component to update info */
  const [newPrearrival, setNewPrearrival] = useState({
    email: "",
    phoneNumber: "",
  })

  const hotelName = props.hotel?.getHotelName()
  const [queryString, setQueryString] = useState<any>({
    any: "",
    email: "",
    confirmationNumber: "",
    firstName: "",
    lastName: "",
    checkInDate: hotelName.toLowerCase().includes("mini") ? dayjs().format("YYYY-MM-DD") : "", // mini only show >= today's booking, other show all
  })

  /* for initial get all records */
  useEffect(() => {
    getData()
  }, [fetchCount, pagination.page, pagination.itemsPerPage, pagination.sortBy, queryString.checkInDate])

  /* auto get records after 2 seconds by the queryString conditions */
  // useEffect(() => {
  //   if (!initialFetch)
  //     setTimeout(() => {
  //       console.log("search again",)
  //       getData()
  //       setPreArrivals(null)
  //     }, 2000)
  // }, [queryString])

  const getData = async () => {
    const query = getQueryString()
    setLoading(true)
    try {
      const paginationQuery = new URLSearchParams({
        page: String(pagination.page),
        itemsPerPage: String(pagination.itemsPerPage),
        sortBy: String(pagination.sortBy),
      }).toString()
      const result = await getPrearrivalsRecord(
        `?${[query, paginationQuery].filter((item) => item).join("&")}`
      )
      if (!result) return

      const { data, pagination: paginationInfo } = result
      setPagination((prev: any) => ({
        ...prev,
        total: paginationInfo?.total ?? prev.total,
        totalPages: paginationInfo?.totalPages ?? prev.totalPages,
      }))
      if (!isDmel) {
        setPreArrivals([...(data || [])])
      } else {
        setPreArrivals([
          ...(data || []).map((item: any) => {
            return {
              ...item,
              guestInputAt: dayjs(item.guestInputAt).add(2, "hours"),
              sendAt: dayjs(item.sendAt).add(2, "hours"),
            }
          }),
        ])
      }
    } catch (err) {
      console.error("PreArrival getData err:", err)
    } finally {
      setLoading(false)
    }
  }

  const getQueryString = () => {
    // console.log(queryString) 
    const allEmpty = Object.values(queryString).every((value) => !value)
    // console.log("allEmpty", allEmpty)
    if (allEmpty) return ''

    const queries = Object.keys(queryString)
      .filter(key => {
        return !!queryString[key]
      })
      .map(key => {
        return `"${key}":"${queryString[key]?.trim()}"`
      })
      .join(",")

    // const queries = Object.keys(queryString)
    //   .filter(key => {
    //     return !!queryString[key]
    //   })
    //   .map(key => {
    //     return `${key}=${queryString[key]}`
    //   })
    //   .join("&")

    // console.log("contructed query:", `?${queries}`)

    const conditionJson = queries ? `{${queries}}` : ''
    // console.log("conditionJson",conditionJson)
    return `filter=${conditionJson}`
  }

  const searchByQueryString = async () => {
    setPreArrivals(null)
    await getData()
  }

  const sendPreArrivalNotification = async (preArrival: any) => {
    const response = await sendPreArrivalNotificationEmail(preArrival)
    // console.log("email response:", response)
    return response
  }

  const updateRecordListByBookingNumber = (bookingNumber: string, newEmail: string): void => {
    if (popup.searchBooking) {
      const index = bookings.findIndex((booking: any) => booking.confirmationNumber === bookingNumber)
      // console.log("??bb",index,newEmail,bookings[index])
      bookings.splice(index, 1, { ...bookings[index], email: newEmail })
      setBookings([...bookings])
    } else {
      const index = preArrivals.findIndex((booking: any) => booking.confirmationNumber === bookingNumber)
      // console.log("??aa",index,newEmail,preArrivals[index])
      preArrivals.splice(index, 1, { ...preArrivals[index], email: newEmail })
      setPreArrivals([...preArrivals])
    }
  }

  return <>
    <MessagePopup />
    {/* popup for enter booking search criteria */}
    <FilterPopup {...{ bookingFilter, setBookingFilter, popup, setPopup, fetchCount, setFetchCount, setBookings }}>
      {/* popup for show the booking search results */}
      <BookingResultsPopup {...{ popup, setPopup, setBookingFilter }} >
        <ListTable
          pagination={pagination}
          setPagination={setPagination}
          hotel={hotel}
          isBooking={true}
          preArrivals={preArrivals}
          bookings={bookings}
          setBookings={setBookings}
          editRecord={editRecord}
          setEditRecord={setEditRecord}
          popup={popup}
          setPopup={setPopup}
          sendPreArrivalNotification={sendPreArrivalNotification}
          filter={filter}
          setFilter={setFilter}
          fetchCount={fetchCount}
          setFetchCount={setFetchCount}
          bookingFilter={bookingFilter}
          setBookingFilter={setBookingFilter}
          queryString={queryString}
          setNewPrearrival={setNewPrearrival}
        />
      </BookingResultsPopup>
    </FilterPopup>
    <EditPopup {...{
      hotel: props.hotel,
      updateRecordListByBookingNumber,
      popup,
      setPopup,
      editRecord,
      setEditRecord,
      fetchCount,
      setFetchCount,
      newPrearrival,
      setNewPrearrival,
    }} />
    <DeletePopup {...{ popup, setPopup, editRecord, fetchCount, setFetchCount }} />
    {
      (!preArrivals || loading) ?
        <Loader text="loading..." /> :
        <>
          <FilterBar {...{ queryString, setQueryString, loading, fetchCount, setFetchCount }} />
          <Statistic pagination={pagination} />
          <ListTable
            pagination={pagination}
            setPagination={setPagination}
            hotel={hotel}
            preArrivals={preArrivals}
            setEditRecord={setEditRecord}
            editRecord={editRecord}
            popup={popup}
            setPopup={setPopup}
            sendPreArrivalNotification={sendPreArrivalNotification}
            filter={filter}
            setFilter={setFilter}
            fetchCount={fetchCount}
            setFetchCount={setFetchCount}
            bookingFilter={bookingFilter}
            setBookingFilter={setBookingFilter}
            queryString={queryString}
            setNewPrearrival={setNewPrearrival}
          />
        </>
    }

    <Popup content='Search booking records' trigger={
      <div
        className="flex w-12 h-12 rounded-full bg-yellow-300 fixed bottom-10 right-10 cursor-pointer"
        onClick={() => {
          // setFilter({ ...filter, filtering: true })
          setPopup({ ...popup, searchBooking: true })
        }}
      >
        <Icon style={{ margin: "auto" }} color="black" name="search" size="large" />
      </div>
    } />

  </>
}
